import InactivityModal from './InactivityModal.view';

export default InactivityModal;
